import { useQuery, UseQueryResult } from 'react-query'
import request from '../request'

export const useGetAgencyStatsByAgencyId = (
  agency_id?: string,
): UseQueryResult<
  { campaigns_count: number; associated_dealerships_count: number; budget: number },
  Error
> => {
  return useQuery(
    ['agencies', { agency_id }, 'stats'],
    ({ signal }) =>
      request<{
        data: {
          campaigns_count: number
          associated_dealerships_count: number
          budget: number
        }
      }>({
        url: `/agencies/${agency_id}/stats`,
        method: 'GET',
        signal,
      }).then((res) => res.data),
    {
      enabled: !!agency_id,
    },
  )
}
